<div class="dashboard-header" fxLayout="row">
  <div class="dashboard-header__sidebar" fxLayout="row">
    <div class="dashboard-header__sidebar-title" fxFlex="85" fxLayout="row" (click)="navigateHome()">
      <img
        class="dashboard-header__sidebar-title-image"
        [src]="selectedStudy ? images[selectedStudy?.type] : images.default"
        alt="page logo"
      />
      <div fxFlex fxLayoutAlign=" center">
        {{ selectedStudy ? titles[selectedStudy.type] : titles.default }}
      </div>
    </div>
  </div>
  <div class="dashboard-header__main" fxFlex fxLayout="column">
    <div
      class="dashboard-header__main-name-row"
      [ngClass]="
        selectedStudy
          ? selectedStudy?.type === StudyType.TIIM
            ? 'tiim-theme-header-main'
            : 'cc-theme-header-main'
          : 'dashboard-theme'
      "
      fxLayout="row"
      fxLayoutAlign="end center"
      fxLayoutGap="25px"
    >
      <div *dashboardHasRole="role?.ADMIN" (click)="navigateToSettings()" #tooltip="matTooltip" matTooltip="Settings">
        <mat-icon class="dashboard-header__main-name-row-icons">settings</mat-icon>
      </div>
      <a (click)="openPrivacyPolicy()" #tooltip="matTooltip" matTooltip="Privacy Policy">
        <mat-icon class="dashboard-header__main-name-row-icons">privacy_tip_outline</mat-icon>
      </a>
      <a (click)="openYoutubeDialog()" #tooltip="matTooltip" matTooltip="Youtube Tutorials">
        <mat-icon class="dashboard-header__main-name-row-icons">help_outline</mat-icon>
      </a>
      <a #tooltip="matTooltip" matTooltip="Logout" (click)="logout()">
        <mat-icon class="dashboard-header__main-name-row-icons">logout</mat-icon>
      </a>
    </div>
    <div
      class="dashboard-header__main-breadcrumb-row"
      [ngClass]="
        selectedStudy
          ? selectedStudy?.type === StudyType.TIIM
            ? 'tiim-theme-header-bottom'
            : 'cc-theme-header-bottom'
          : 'dashboard-theme'
      "
      fxLayout="row"
      fxLayoutAlign="space-between center"
    >
      <div class="dashboard-header__main-breadcrumb-row-breadcrumbs">
        <ol fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
          <li *ngFor="let breadcrumb of breadcrumbs$">
            <span [routerLink]="breadcrumb.url" routerLinkActive="router-link-active">
              {{ breadcrumb.label }}
            </span>
          </li>
        </ol>
      </div>

      <div
        class="dashboard-header__main-breadcrumb-row-languages"
        fxLayout="row"
        *ngIf="(supportedLanguages$ | async)?.length > 1"
      >
        <a
          *ngFor="let language of supportedLanguages$ | async"
          [class.active]="language.code === (selectedLanguage$ | async)?.code"
          class="dashboard-header__main-breadcrumb-row-languages-links"
          (click)="changeActiveLanguage(language)"
        >
          {{ language.name | uppercase }}
        </a>
      </div>
    </div>
  </div>
</div>
